import request from '@/utils/request'

// 首行车辆数据
export function vehicleFirstLine() {
  return request({
    url: '/system/api/admin/index/vehicle/firstLine',
    method: 'get'
  })
}

// IOT设备新增趋势
export function vehicleNewIotDeviceTrends(data) {
  return request({
    url: '/system/api/admin/index/vehicle/newIotDeviceTrends',
    method: 'get',
    params: data
  })
}

// 故障情况
export function vehicleFault(data) {
  return request({
    url: '/system/api/admin/index/vehicle/fault',
    method: 'get',
    params: data
  })
}

// 订单编辑
export function orderEdit(data) {
  return request({
    url: '/system/api/admin/order/edit',
    method: 'post',
    data
  })
}

// 订单修改状态
export function orderStatus(data) {
  return request({
    url: '/system/api/admin/order/status',
    method: 'post',
    data
  })
}

// 首行运营数据
export function operationFirstLine() {
  return request({
    url: '/system/api/admin/index/operation/firstLine',
    method: 'get'
  })
}

// 运营-管理系统登录情况
export function operationLoginlogshow(data) {
  return request({
    url: '/system/api/admin/index/operation/loginlogshow',
    method: 'get',
    params: data
  })
}

// 运营-功能页面点击
export function functionpageclick(data) {
  return request({
    url: '/system/api/admin/index/operation/functionpageclick',
    method: 'post',
    data
  })
}

// 运营-功能页面折线图展示
export function functionpageshow(data) {
  return request({
    url: '/system/api/admin/index/operation/functionpageshow',
    method: 'get',
    params: data
  })
}

// 运营-获取功能页面 pageName下拉框
export function listPageName(data) {
  return request({
    url: '/system/api/admin/index/operation/listPageName',
    method: 'get',
    params: data
  })
}

// 售车系统 首行数据
export function saleFirstLine() {
  return request({
    url: '/system/api/admin/index/sale/firstLine',
    method: 'get'
  })
}

// 售车系统 用户数据分页
export function appUserPage(data) {
  return request({
    url: '/system/api/admin/index/sale/appUserPage',
    method: 'get',
    params: data
  })
}

// 首行数据
export function dataOverViewFirstLine() {
  return request({
    url: '/system/api/admin/dataoverview/firstLine',
    method: 'get'
  })
}

// 数据总览热力图
export function getEbikeMap(data) {
  return request({
    url: '/system/api/admin/static/getEbikeMap',
    method: 'post',
    data
  })
}

// 数据总览-IOT设备新增趋势
export function newIotDeviceTrends(data) {
  return request({
    url: '/system/api/admin/dataoverview/newIotDeviceTrends',
    method: 'get',
    params: data
  })
}

// 数据总览-故障新增趋势
export function newFaultTrends(data) {
  return request({
    url: '/system/api/admin/dataoverview/newFaultTrends',
    method: 'get',
    params: data
  })
}

// 数据总览-故障新增趋势-饼图
export function findFaultTrends(data) {
  return request({
    url: '/system/api/admin/dataoverview/findFaultTrends',
    method: 'get',
    params: data
  })
}

// 数据总览-查询厂商/商户/加盟商
export function listTenantId(data) {
  return request({
    url: '/system/api/admin/tenant/listTenantId',
    method: 'get',
    params: data
  })
}

// 数据总览-Top5厂商
export function top5Manufacturer() {
  return request({
    url: '/system/api/admin/dataoverview/top5Manufacturer',
    method: 'get'
  })
}

// 数据总览-厂商新增趋势
export function newManufacturerTrends(data) {
  return request({
    url: '/system/api/admin/dataoverview/newManufacturerTrends',
    method: 'get',
    params: data
  })
}

// 数据总览-商户累计新增趋势
export function newMerchantTrends(data) {
  return request({
    url: '/system/api/admin/dataoverview/newMerchantTrends',
    method: 'get',
    params: data
  })
}

// 获取电池高温告警统计（首页铃铛）
export function findLatestBcstMsgCount(data) {
  return request({
    url: '/ebike/listek-ebike/web/fault/findBatteryWarnCount',
    method: 'post',
    data
  })
}

// 获取电池高温告警列表（首页铃铛）
export function findLatestBcstMsgList(data) {
  return request({
    url: '/ebike/listek-ebike/web/fault/findBatteryWarnList',
    method: 'post',
    data
  })
}

// 获取系统通知广播消息列表（仅最近 1 小时未读，与 WebMsgService 后端窗口一致；不含更早历史）
export function findWebBcstMsgList(data) {
  return request({
    url: '/ebike/listek-ebike/web/msg/findLatestBcstMsgList',
    method: 'post',
    data
  })
}
